// Backend contract for model comments (BE PR #16458). Comments attach
// polymorphically to a Generator::Run and are addressed through the
// community-models namespace, keyed by the run slug (never the raw id).
export const MAX_COMMENT_LENGTH = 1000

const communityModelPath = slug => `/api/internal/generator/community-models/${slug}`

// Run-scoped comment collection (index/create) and member (update/destroy).
export const commentsPath = slug => `${communityModelPath(slug)}/comments`

export const commentPath = (slug, commentId) => `${commentsPath(slug)}/${commentId}`

// Mirrors the controller's PER_PAGE; only a fallback - the index meta.perPage
// overrides it as soon as the first page lands.
export const COMMENTS_PER_PAGE = 20

// Optimistic nodes carry a client-side id until the create response lands. They
// are not addressable on the server, so nothing may act on them by id.
const TEMP_ID_PREFIX = 'temp-'

export const buildPendingCommentId = () => `${TEMP_ID_PREFIX}${Date.now()}`

export const isPendingCommentId = id => String(id).startsWith(TEMP_ID_PREFIX)

// Matches the backend `exceeds_comment_quota` message (config/locales/cgtrader/en/errors.yml).
// That key is EN-only server-side, so the detail never localizes and this substring match is stable.
export const COMMENT_QUOTA_PATTERN = /commenting limit/i
